import { render, staticRenderFns } from "./BulkMessages.vue?vue&type=template&id=12ea5f33&"
import script from "./BulkMessages.vue?vue&type=script&lang=js&"
export * from "./BulkMessages.vue?vue&type=script&lang=js&"
import style0 from "./BulkMessages.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports